module.exports = __webpack_public_path__ + "static/media/increase-icon.94eb8155.svg";